import {Component, inject, Input, Signal} from '@angular/core';
import {
  CorporateInfoInterface, RegionalInfoInterface,
} from './retailer-info.interface';
import {IconCardComponent} from '../icon-card/icon-card.component';
import {MatGridListModule} from '@angular/material/grid-list';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs';
import {ResolutionsInterface} from '../../../../services/media-query/resolutions.interface';
import {MediaQueryService} from '../../../../services/media-query/media-query.service';
import {gutterSizer, rowSizer} from '../../dahsboard.utils';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-retailer-section',
  templateUrl: './retailer-section.component.html',
  styleUrls: ['./retailer-section.component.scss'],
  standalone: true,
  imports: [
    IconCardComponent,
    MatGridListModule,
    CommonModule,
    NgOptimizedImage,
    MatTooltipModule
  ],
})
export class RetailerSectionComponent {
  @Input() corporationInfo: CorporateInfoInterface | undefined;
  @Input() sector: string | undefined;
  @Input() companyType: string | undefined;
  @Input() hqRegion: RegionalInfoInterface | undefined;
  @Input() marketCap: number | undefined | null;
  @Input() retailerIRN: string | undefined;
  @Input() retailerProfileUrl: string | undefined;

  public get inputData(): { irn: string; profileUrl: string } {
    return {
      irn: this.retailerIRN || 'N/A', // Provide a default value if undefined
      profileUrl: this.retailerProfileUrl || 'N/A', // Provide a default value if undefined
    };
  }

  private mediaService: MediaQueryService = inject(MediaQueryService);
  public gutterSizing: Signal<string> = toSignal(
    this.mediaService.getDisplayType().pipe(map(gutterSizer)),
    { initialValue: '0' }
  );
  public rowSizing: Signal<string> = toSignal(
    this.mediaService.getDisplayType().pipe(map(rowSizer)),
    { initialValue: '0' }
  );
  public isMobile: Signal<boolean> = toSignal(
    this.mediaService.getDisplayType().pipe(map(({ isMobile }) => isMobile)),
    { initialValue: window.innerWidth < 768 }
  );

  public get corporateName(): string {
    return this.corporationInfo?.name ? this.corporationInfo.name : 'N/A';
  }

  public get sectorName(): string {
    return this.sector ? this.sector : 'N/A';
  }

  public get companyTypeName(): string {
    return this.companyType ? this.companyType : 'N/A';
  }

  public get companyTicker(): string {
    return this.corporationInfo?.ticker ? this.corporationInfo.ticker : 'N/A';
  }

  public get countryFlag(): string {
    return this.hqRegion?.code
      ? `https://hatscripts.github.io/circle-flags/flags/${this.hqRegion.code.toLowerCase()}.svg`
      : 'N / A';
  }

  public get countryFlagAltText(): string {
    return this.hqRegion
      ? `Country flag for ${this.hqRegion?.name}`
      : 'Country flag not available';
  }
}

